import styled from 'styled-components';
import colors from '../../assets/colors';

const Alert = styled.div`
  min-width: 220px;
  padding: 15px 20px;
  background: ${(props) => {
    if (props.type === 'error') return `${colors.red}`;
    return `${colors.primary}`;
  }};
  color: #FFF;
  border-radius: 30px;
  margin-top: 25px;

  .fa {
    font-size: 18px;
    margin-right: 12px;
    margin-bottom: -3px;
  }

  @media screen and (min-width: 767px) {
    min-width: 380px;
  }
`;

export default Alert;
